import { put, select, takeLatest } from 'redux-saga/effects'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import { CrewConstants } from '../../crew/store/crew.constants'
import { getCrewSelector } from '../../crew/selectors'
import { ICrewState } from '../../crew/store/crew.types'
import { IConfigurationOptionsState } from '../../options/store/options.types'
import { getConfigurationOptionsSelector } from '../../options/selectors'
import * as actions from '../store/configurations.actions'
import { IConfigurationsState } from '../store/configurations.types'
import { getConfigurationsSelector } from '../selectors/configurations.selector'
import { ConfigurationsConstants } from '../store/configurations.constants'

export function* setTimeZone() {
  const configuration: IConfigurationsState = yield select(getConfigurationsSelector)
  const configurationOptions: IConfigurationOptionsState = yield select(getConfigurationOptionsSelector)
  const crewState: ICrewState = yield select(getCrewSelector)
  const { serviceConfig } = configuration
  const { base } = crewState
  const { timeZoneOptions } = configurationOptions
  if (base) {
    const index = timeZoneOptions.findIndex((option) => option.id === base.timezone)
    if (index > -1) {
      const timeZone = timeZoneOptions[index]
      yield put(actions.setTimeZone(timeZone))
    } else if (serviceConfig && serviceConfig.TIMEZONE && timeZoneOptions) {
      const selectedServiceTimeZone = timeZoneOptions.filter((option) => option.id === serviceConfig.TIMEZONE)[0]
      yield put(actions.setTimeZone(selectedServiceTimeZone))
    } else {
      yield put(actions.setTimeZone({ name: ConfigurationsConstants.DEFAULT_TIMEZONE }))
    }
  } else if (serviceConfig && serviceConfig.TIMEZONE && timeZoneOptions) {
    const selectedServiceTimeZone = timeZoneOptions.filter((option) => option.id === serviceConfig.TIMEZONE)[0]
    yield put(actions.setTimeZone(selectedServiceTimeZone))
  } else {
    yield put(actions.setTimeZone({ name: ConfigurationsConstants.DEFAULT_TIMEZONE }))
  }
}

export function* setTimeZoneSaga() {
  yield takeLatest([PCRConstants.CREATE_PCR, CrewConstants.SET_BASE], setTimeZone)
}
